import type { ReactNode } from 'react';

export const symbol_flashlight_on: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M330-140v-383l-80-117q-5.38-7.73-7.69-16.23Q240-664.73 240-674v-146q0-24.75 17.63-42.38Q275.25-880 300-880h360q24.75 0 42.38 17.62Q720-844.75 720-820v146q0 9.27-2.31 17.77T710-640l-80 117v383q0 24.75-17.62 42.37Q594.75-80 570-80H390q-24.75 0-42.37-17.63Q330-115.25 330-140Zm114-200.82q-15-14.83-15-36Q429-398 443.82-413q14.83-15 36-15Q501-428 516-413.18q15 14.83 15 36Q531-356 516.18-341q-14.83 15-36 15Q459-326 444-340.82ZM300-764h360v-56H300v56Zm360 60H300v35l90 131v398h180v-398l90-131v-35ZM480-480Z"
		/>
	</svg>
);
